import { Field } from "react-final-form";

import { PhoneNumberWithPrefixInputFieldProps } from "./types";

import PhoneNumberWithPrefixInput from ".";

const PhoneNumberWithPrefixInputField: React.FC<
  PhoneNumberWithPrefixInputFieldProps
> = ({ name, ...props }) => (
  <Field
    {...{ name }}
    render={({
      input,
      meta: { touched, modifiedSinceLastSubmit, error, submitError },
    }) => (
      <PhoneNumberWithPrefixInput
        error={touched && !modifiedSinceLastSubmit && (error || submitError)}
        {...input}
        {...props}
      />
    )}
  />
);

export default PhoneNumberWithPrefixInputField;
